import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Mount a dashboard view on first use, then hide it without destroying its
 * local cache. The caller owns invalidation through the view's normal props.
 */
export default function PersistentDashboardView({ active, mountWhenInactive = false, children }) {
    const visitedRef = useRef(false);
    if (active || mountWhenInactive) {
        visitedRef.current = true;
    }
    if (!visitedRef.current) {
        return null;
    }
    return (
        <Box
            aria-hidden={!active}
            data-testid="persistent-dashboard-view"
            sx={{ display: active ? 'block' : 'none' }}
        >
            {children}
        </Box>
    );
}

PersistentDashboardView.propTypes = {
    active: PropTypes.bool.isRequired,
    mountWhenInactive: PropTypes.bool,
    children: PropTypes.node.isRequired,
};
